import request from './request'

export function listOffer(data) {
  return request.post('/supply/offers/list', data)
}
export function getOffer(id) {
  return request.get('/supply/offers/' + id)
}
export function saveOffer(data) {
  return request.post('/supply/offers', data)
}
export function updateOffer(data) {
  return request.post('/supply/offers/update', data)
}
export function deleteOffer(ids) {
  return request.post('/supply/offers/delete', ids)
}
export function acceptOffer(offerId) {
  return request.post('/supply/offers/accept', { offerId })
}
export function declineOffer(offerId) {
  return request.post('/supply/offers/decline', { offerId })
}
export function createPurchaseDeliveryFromOffer(offerId) {
  return request.post('/supply/offers/create-purchase-delivery', { offerId })
}
